import React from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("white", "white");

  return (
    <Box
      minH="73vh"
      bg={bgColor}
      color="white"
      display="flex"
      alignItems="flex-start" // Changed from "center" to "flex-start" to align at the top
      justifyContent="center"
      p={0}
      shadow="lg"
      borderRadius="md"
      pt={10} // Added padding-top to give some spacing from the very top
    >
      {/* Θ⓿◍㉦ఠ  */}
      <VStack spacing={6} textAlign="center">
        <Box bg={"#f1f4fb"} shadow="lg" borderRadius="lg" p={5}>
          <Heading letterSpacing="widest" color="#17263a">
            Oops!
          </Heading>
          <Heading
            fontSize={{ base: "8xl", md: "9xl" }}
            fontWeight="extrabold"
            letterSpacing="widest"
            color="#17263a"
          >
            4Θ4
          </Heading>
          <VStack p={3}>
            <Text fontSize="xl" maxW="lg" color="black">
              Sorry, an error has occured, Requested Page not found!
            </Text>
            <Text fontSize="md" color="black">
              You may have mistyped the address or the page may have moved.
            </Text>
          </VStack>

          <Button
            size="lg"
            bg="#17263a"
            color="white"
            variant="solid"
            onClick={() => navigate("/")}
            leftIcon={<MdArrowBack />}
            boxShadow="lg"
            _hover={{ bg: "#2a3e5c" }} // lighter shade of #17263a
          >
            Back to Dashboard
          </Button>
        </Box>
      </VStack>
    </Box>
  );
};

export default NotFound;
